import useAppContext from 'flow/hooks/useAppContext';
import { TranscriptionExtendedAction } from 'flow/types/CallRecord';
import { TicketKey } from 'flow/types/EntityKeys';
import CardCallDetailsContainer from 'flow/components/pbx/v2/misc/CardCallDetailsContainer';
import SectionTitle from 'flow/components/pbx/v2/detail-page/SectionTitle';
import CallSummaryContextMenu from 'flow/components/tickets/v2/event-item/call-event/CallSummaryContextMenu/CallSummaryContextMenu';
import TranscriptionSummary, { revealDurationMs } from './TranscriptionSummary';
import TranscriptionActionPoints from './TranscriptionActionPoints';

interface Props {
    summary?: string;
    actions?: TranscriptionExtendedAction[];
    animate?: boolean;
    // Ticket context only: shows a "…" menu (suggest tags, copy summary) at the card's top-end.
    displayTicketActions?: boolean;
    ticketKey?: TicketKey;
}

// Small beat between the summary stream finishing and the action points revealing,
// so the transition reads as a deliberate handoff rather than a continuation.
const ACTIONS_POST_SUMMARY_DELAY_MS = 80;

const CardTranscriptionSummary = ({
    summary,
    actions,
    animate,
    displayTicketActions,
    ticketKey,
}: Props) => {
    const { i18next } = useAppContext();

    const summaryRevealDurationMs = revealDurationMs(summary?.length ?? 0);

    const actionsStartDelayMs = animate
        ? summaryRevealDurationMs + ACTIONS_POST_SUMMARY_DELAY_MS
        : 0;

    return (
        <CardCallDetailsContainer className="flex-col gap-3">
            <div className="flex flex-col">
                <div className="flex items-start justify-between">
                    <SectionTitle title={i18next.t('ai.summary.summary')} />
                    {displayTicketActions && ticketKey && (
                        <CallSummaryContextMenu
                            ticketKey={ticketKey}
                            summary={summary}
                        />
                    )}
                </div>
                <TranscriptionSummary summary={summary} animate={animate} />
            </div>
            <TranscriptionActionPoints
                actions={actions}
                animate={animate}
                startDelayMs={actionsStartDelayMs}
            />
        </CardCallDetailsContainer>
    );
};

export default CardTranscriptionSummary;
